import { createStore } from 'vuex'
import dispatchActionForAllModules from '@utils/dispatch-action-for-all-modules'

import modules from './modules'

// Transitional Vuex 4 store. Modules are being migrated to Pinia incrementally;
// this keeps existing `mapState`/`dispatch`/`getters` consumers working until then.
const store = createStore({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  strict: process.env.NODE_ENV !== 'production',
})

export default store

// Automatically run the `init` action for every module, if one exists.
dispatchActionForAllModules('init')
